import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import SAR from "@componentsShared/SAR/SAR";
import { CDN_LINK } from "@globalConfig";
import WarrantyCollapsedHeader from "@/pages/checkout/components/PaymentInfo/WarrantyCollapsedHeader";
var DrawerPaymentInfo = function DrawerPaymentInfo(_ref) {
  var _checkoutOrder$regist, _checkoutOrder$shippi, _checkoutOrder$roadSe;
  var checkoutOrder = _ref.checkoutOrder,
    _ref$hideData = _ref.hideData,
    hideData = _ref$hideData === void 0 ? false : _ref$hideData,
    _ref$showOrderNumber = _ref.showOrderNumber,
    showOrderNumber = _ref$showOrderNumber === void 0 ? false : _ref$showOrderNumber,
    onClickInfoIcon = _ref.onClickInfoIcon,
    children = _ref.children;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    tShort = _useTranslation.tShort;

  /* ── shared row classes ─────────────────────────────── */
  var row = "flex justify-between flex-wrap mt-4 gap-1";
  var rowLabel = "text-[#484848] text-sm leading-6 font-semibold";
  var rowValue = "text-[#484848] text-base leading-6 font-bold";
  var rowNote = "w-full text-[#6c7a8d] text-[10px] leading-4";
  return /*#__PURE__*/React.createElement("div", {
    className: "box-border px-6 pb-8"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "block font-bold text-[#484848] text-xl leading-8 border-solid text-center pb-5 border-b border-[#D6DFE9]"
  }, tShort("drawer_payment/price_details", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-[#d6dfe9] pt-4 flex flex-col gap-0"
  }, showOrderNumber && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id) && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center border-b border-[#d6dfe9] px-2 py-3 mb-2"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-[#484848] text-xs leading-6"
  }, tShort("drawer_payment/order_number", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_order-id",
    className: "text-[#484848] text-base leading-6"
  }, checkoutOrder.id)), ((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_price) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_price) == 0) && /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement("span", {
    className: rowLabel
  }, tShort("drawer_payment/car_price", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_car-price",
    className: rowValue
  }, checkoutOrder.post_price, /*#__PURE__*/React.createElement("span", {
    className: "text-xl font-normal mx-1"
  }, /*#__PURE__*/React.createElement(SAR, null))), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_is_new) == 0 && /*#__PURE__*/React.createElement("p", {
    className: rowNote
  }, tShort("drawer_payment/price_includes_vat", {
    ns: "web_checkout_cash"
  })), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.limited_quantity) && /*#__PURE__*/React.createElement("p", {
    className: rowNote
  }, tShort("drawer_payment/price_may_change", {
    ns: "web_checkout_cash"
  }))), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.warrantyPriceDetailsV3) && /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement(WarrantyCollapsedHeader, {
    warrantyPriceDetails: checkoutOrder.warrantyPriceDetailsV3
  })), /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement("span", {
    className: rowLabel
  }, tShort("drawer_payment/vat_on_services", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_vat-price",
    className: rowValue
  }, checkoutOrder.vat, /*#__PURE__*/React.createElement("span", {
    className: "text-xl font-normal mx-1"
  }, /*#__PURE__*/React.createElement(SAR, null))), /*#__PURE__*/React.createElement("p", {
    className: rowNote
  }, tShort("drawer_payment/vat_note", {
    ns: "web_checkout_cash"
  }))), ((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.registration_fees) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.registration_fees) == 0) && /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement("span", {
    className: rowLabel
  }, checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.post_is_new ? tShort("drawer_payment/registration_plates", {
    ns: "web_checkout_cash"
  }) : tShort("drawer_payment/ownership_transfer", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_registration-fees",
    className: rowValue
  }, parseInt(checkoutOrder.registration_fees) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, checkoutOrder.registration_fees, " ", /*#__PURE__*/React.createElement("span", {
    className: "text-xl font-normal mx-1"
  }, /*#__PURE__*/React.createElement(SAR, null))) : /*#__PURE__*/React.createElement("span", {
    className: "flex flex-col items-center text-[#00b362] text-xl"
  }, tShort("drawer_payment/free", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-[#6c7a8d] underline text-base leading-[18px] line-through decoration-skip-ink-none"
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$regist = checkoutOrder.registrationPriceDetails) === null || _checkoutOrder$regist === void 0 ? void 0 : _checkoutOrder$regist.oldPrice, " ", /*#__PURE__*/React.createElement(SAR, null))))), ((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.shipping_fees) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.shipping_fees) == 0) && /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement("span", {
    className: rowLabel
  }, tShort("drawer_payment/shipping", {
    ns: "web_checkout_cash"
  })), checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.shipping_fees_show_note ? /*#__PURE__*/React.createElement("div", {
    className: "flex gap-[9px] w-[150px] items-center justify-end cursor-pointer hasEvents",
    onClick: function onClick() {
      return onClickInfoIcon === null || onClickInfoIcon === void 0 ? void 0 : onClickInfoIcon();
    }
  }, /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_shipping-fees",
    className: "text-[#6D7A8D] text-sm font-bold leading-6"
  }, tShort("drawer_payment/shipping_tbd", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("img", {
    className: "hasEvents cursor-pointer",
    src: CDN_LINK + "/assets/images/Vector.svg",
    alt: "icon"
  })) : /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_shipping-fees",
    className: rowValue
  }, parseInt(checkoutOrder.shipping_fees) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, checkoutOrder.shipping_fees, " ", /*#__PURE__*/React.createElement("span", {
    className: "text-xl font-normal mx-1"
  }, /*#__PURE__*/React.createElement(SAR, null))) : /*#__PURE__*/React.createElement("span", {
    className: "flex flex-col items-center text-[#00b362] text-xl"
  }, tShort("drawer_payment/free", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-[#6c7a8d] underline text-base leading-[18px] line-through decoration-skip-ink-none"
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$shippi = checkoutOrder.shippingPriceDetails) === null || _checkoutOrder$shippi === void 0 ? void 0 : _checkoutOrder$shippi.oldPrice, " ", /*#__PURE__*/React.createElement(SAR, null))))), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.coupon_fees) && /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement("span", {
    className: rowLabel
  }, tShort("post_info/coupon_fees", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("strong", {
    className: rowValue
  }, checkoutOrder.coupon_fees, " ", /*#__PURE__*/React.createElement("span", {
    className: "text-xl font-normal mx-1"
  }, /*#__PURE__*/React.createElement(SAR, null)))), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.roadService) && Object.keys(checkoutOrder.roadService).length > 0 && /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement("span", {
    className: rowLabel
  }, checkoutOrder.roadService.name, /*#__PURE__*/React.createElement("p", {
    className: "w-full text-[#6c7a8d] text-[10px] leading-4"
  }, checkoutOrder.roadService.text)), /*#__PURE__*/React.createElement("strong", {
    className: "flex flex-col items-center text-[#00b362] text-xl"
  }, checkoutOrder.roadService.old_price && /*#__PURE__*/React.createElement("span", {
    className: "text-[#6c7a8d] underline text-base leading-[18px] line-through decoration-skip-ink-none"
  }, checkoutOrder.roadService.old_price, /*#__PURE__*/React.createElement(SAR, null), " "), checkoutOrder.roadService.price === "0" ? /*#__PURE__*/React.createElement("span", {
    className: "flex flex-col items-center text-[#00b362] text-xl"
  }, tShort("drawer_payment/free", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-[#6c7a8d] underline text-base leading-[18px] line-through decoration-skip-ink-none"
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$roadSe = checkoutOrder.roadServicePriceDetail) === null || _checkoutOrder$roadSe === void 0 ? void 0 : _checkoutOrder$roadSe.oldPrice, " ", /*#__PURE__*/React.createElement(SAR, null))) : /*#__PURE__*/React.createElement("span", {
    className: rowValue
  }, checkoutOrder.roadService.price))), checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.referral_discount && checkoutOrder.referral_discount != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between flex-nowrap border-t-2 border-[#d6dfe9] pt-6"
  }, /*#__PURE__*/React.createElement("span", {
    className: rowLabel
  }, tShort("drawer_payment/referral_discount", {
    ns: "web_checkout_cash"
  }), " (", checkoutOrder.referral_code, ")"), /*#__PURE__*/React.createElement("strong", {
    className: rowValue
  }, checkoutOrder.referral_discount, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(SAR, null)))) : null, checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.service_amount || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.service_amount) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement("span", {
    className: rowLabel
  }, tShort("drawer_payment/added_services", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    className: rowValue
  }, checkoutOrder.service_amount, /*#__PURE__*/React.createElement(SAR, null))) : null, checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.vas_amount || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.vas_amount) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement("span", {
    className: rowLabel
  }, tShort("drawer_payment/added_vat", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    className: rowValue
  }, checkoutOrder.vas_amount, /*#__PURE__*/React.createElement(SAR, null)), /*#__PURE__*/React.createElement("p", {
    className: rowNote
  }, tShort("drawer_payment/vat_note", {
    ns: "web_checkout_cash"
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between flex-wrap border-t border-solid text-center pb-2 border-[#D6DFE9] pt-4 box-border border-b border-b-[3px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] text-sm leading-6 font-bold"
  }, tShort("drawer_payment/total", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_total-price",
    className: "text-[#484848] text-xl leading-[22px] font-bold"
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.total_price, /*#__PURE__*/React.createElement("span", {
    className: "!text-2xl font-normal mx-1"
  }, /*#__PURE__*/React.createElement(SAR, null)))), !hideData && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between flex-nowrap border-t-2 border-[#d6dfe9] pt-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] text-sm leading-6 font-semibold"
  }, tShort("drawer_payment/arboun_label", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6D7A8D] text-xs leading-5 pe-4"
  }, tShort("drawer_payment/arboun_note", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_arboun-fees",
    className: "text-[#00b362] text-xl leading-[22px] font-bold"
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.arboun, /*#__PURE__*/React.createElement("span", {
    className: "!text-2xl font-normal mx-1"
  }, /*#__PURE__*/React.createElement(SAR, null)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "!text-xs font-normal"
  }, tShort("drawer_payment/arboun_refundable", {
    ns: "web_checkout_cash"
  }))))), children);
};
export default DrawerPaymentInfo;